// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" width="8" height="2"><path data-name="Path 8585" d="M7 2H1a1 1 0 010-2h6a1 1 0 010 2z" fill="#51bb7b"/></svg>
);

export default fn;
